import type { ComponentPropsWithRef } from 'react';

import { clsx } from '~/styles/utils';

import { buttonGroupStyle } from './Button.css';

type Props = ComponentPropsWithRef<'div'>;

export const ButtonGroup = ({ children, ...delegated }: Props) => {
  return (
    <div {...delegated} className={clsx(buttonGroupStyle, delegated.className)}>
      {children}
    </div>
  );
};
